<template>
  <div class="card">
    <div class="card-body p-0">
      <cardHead
        :title="'Customer Providers'"
        :key="isSelectCount"
        :buttons="[
          {
            title: 'Remove From Redis',
            icon: 'mdi mdi-layers-off',
            emit: 'removeFromRedisAll',
            class:
              'btn-danger ' +
              (data != null &&
              data.filter((x) => {
                return x.isSelected;
              }).length == 0
                ? 'none'
                : ''),
          },
          {
            title: 'Scan To Queue',
            icon: 'fas fa-sync-alt',
            emit: 'scanToQueue',
            class:
              'btn-primary ' +
              (data != null &&
              data.filter((x) => {
                return x.isSelected;
              }).length == 0
                ? 'none'
                : ''),
          },
          {
            title: 'Reload',
            icon: 'fa fa-sync',
            emit: 'reload',
          },
        ]"
        @add="addShow = true"
        @reload="get()"
        @removeFromRedisAll="removeFromRedisAll"
        @scanToQueue="scanToQueue"
      ></cardHead>
      <div class="tables rel">
        <div
          class="myCheckBox abs"
          style="    top: 47px;
    z-index: 5;
    left: 6px;"
        >
          <input
            type="checkbox"
            class="filled-in"
            v-model="selectAll"
            id="chckMassConfirmable"
          /><label for="chckMassConfirmable"></label>
        </div>
        <dataTable
          :name="'AllCustomerProviders'"
          ref="agGrid"
          :columnDefs="columnDefs"
          :data="data"
          @removeFromRedis="removeFromRedis($event)"
          @scanErrors="scanErrorsPop = $event.Id"
          @scan="scan"
          @auth="auth"
          @scanQue="scanQue"
          @testConnection="testConnection($event)"
          @cellClicked="clickedCellRezGrid"
          @remove="remove"
          :addContextMenuItem="getContextMenuItems"
          :rowClassRules="{
            // row style function
            danger: (params) => {
              // var numSickDays = params.data;
              return params?.data?.ControlRequired;
            },
          }"
        ></dataTable>
      </div>
      <errorList
        v-if="scanErrorsPop != null"
        :CustomerProviderId="scanErrorsPop"
        @close="scanErrorsPop = null"
      ></errorList>
      <modal
        :size="'xl'"
        @close="scanResponseOpen = false"
        v-if="scanResponseOpen != false"
      >
        <template #head>
          <div class="modal-header">
            <h4 class="modal-title">Scan Response</h4>
            <button
              class="btn btn-info btn-xs waves-effect waves-light m-l-5"
              type="button"
              @click="
                $root.clipboardCopy(JSON.stringify(scanResponse, null, 2))
              "
              v-if="scanResponse != null"
            >
              <span>Copy</span>
            </button>
          </div>
        </template>
        <template #content>
          <load-area v-if="scanResponse == null"></load-area>
          <pre v-if="scanResponse != null">{{ scanResponse }}</pre>
        </template>
      </modal>
      <modal
        :size="'xl'"
        @close="authResponseOpen = false"
        v-if="authResponseOpen != false"
      >
        <template #head>
          <div class="modal-header">
            <h4 class="modal-title">Auth Response</h4>
            <button
              class="btn btn-info btn-xs waves-effect waves-light m-l-5"
              type="button"
              @click="
                $root.clipboardCopy(JSON.stringify(authResponse, null, 2))
              "
              v-if="authResponse != null"
            >
              <span>Copy</span>
            </button>
          </div>
        </template>
        <template #content>
          <load-area v-if="authResponse == null"></load-area>
          <pre v-if="authResponse != null">{{ authResponse }}</pre>
        </template>
      </modal>
      <modal
        :title="
          'Customer ' +
            openCustomerProviderLogs.ProviderName +
            ' Provider Logs (' +
            openCustomerProviderLogs.Username +
            ')'
        "
        @close="openCustomerProviderLogs = null"
        v-if="openCustomerProviderLogs != null"
        size="xl"
      >
        <template #content>
          <customerProviderLogs
            :customerProviderId="openCustomerProviderLogs.Id"
          ></customerProviderLogs>
        </template>
      </modal>
    </div>
    <detail
      v-if="detailShow != null"
      @update="$refs.agGrid.changeRow('Id', $event)"
      :setModel="detailShow"
      :CustomerId="detailShow.CustomerId"
      @close="detailShow = null"
    ></detail>
  </div>
</template>

<script>
import moment from "moment";
import errorList from "../customers/detail/providers/errorList.vue";
import customerProviderLogs from "./../kolayrez/customerProvidersLogs/list.vue";
import detail from "./../customers/detail/providers/upsert.vue";
export default {
  name: "CustomerProviders",
  components: { errorList, customerProviderLogs, detail },
  data() {
    return {
      columnDefs: [
        {
          headerName: "",
          width: 55,
          filter: false,
          field: "isSelected",
          sortable: false,
          cellClick: true,
          enableRowGroup: true,
          floatingFilter: false,
          cellRenderer: this.$CheckCellRenderer,
        },
        {
          headerName: "Id",
          width: 80,
          filter: "agNumberColumnFilter",
          field: "Id",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "CustomerName",
          filter: "agTextColumnFilter",
          field: "CustomerName",
          flex: 1,
          minWidth: 160,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "ProviderName",
          filter: "agTextColumnFilter",
          field: "ProviderName",
          flex: 1,
          minWidth: 140,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "Username",
          filter: "agTextColumnFilter",
          field: "Username",
          flex: 1,
          minWidth: 120,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "Password",
          filter: "agTextColumnFilter",
          field: "Password",
          flex: 1,
          minWidth: 120,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "Parameter",
          filter: "agTextColumnFilter",
          field: "Parameter",
          flex: 1,
          minWidth: 120,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "LastLoginAttemptDate",
          filter: "agTextColumnFilter",
          field: "LastLoginAttemptDate",
          flex: 1,
          minWidth: 200,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
          valueFormatter: function(params) {
            if (params.value == null) {
              return "";
            } else {
              let diff = new Date().getTimezoneOffset();
              return moment(
                new Date(params.value).setMinutes(
                  new Date(params.value).getMinutes() - diff
                )
              ).format("DD.MM.YYYY HH:mm");
            }
          },
        },
        {
          headerName: "LastLoginDate",
          filter: "agTextColumnFilter",
          field: "LastLoginDate",
          flex: 1,
          minWidth: 140,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
          valueFormatter: function(params) {
            if (params.value == null) {
              return "";
            } else {
              let diff = new Date().getTimezoneOffset();
              return moment(
                new Date(params.value).setMinutes(
                  new Date(params.value).getMinutes() - diff
                )
              ).format("DD.MM.YYYY HH:mm");
            }
          },
        },
        {
          headerName: "LastScanDate",
          filter: "agTextColumnFilter",
          field: "LastScanDate",
          flex: 1,
          minWidth: 140,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
          valueFormatter: function(params) {
            if (params.value == null) {
              return "";
            } else {
              let diff = new Date().getTimezoneOffset();
              return moment(
                new Date(params.value).setMinutes(
                  new Date(params.value).getMinutes() - diff
                )
              ).format("DD.MM.YYYY HH:mm");
            }
          },
        },
        {
          headerName: "LastControlDate",
          filter: "agTextColumnFilter",
          field: "LastControlDate",
          flex: 1,
          minWidth: 150,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
          valueFormatter: function(params) {
            if (params.value == null) {
              return "";
            } else {
              let diff = new Date().getTimezoneOffset();
              return moment(
                new Date(params.value).setMinutes(
                  new Date(params.value).getMinutes() - diff
                )
              ).format("DD.MM.YYYY HH:mm");
            }
          },
        },
        {
          headerName: "StaticProxy",
          width: 120,
          filter: true,
          field: "StaticProxy",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
          floatingFilter: true,
          cellRenderer: this.$CheckCellRenderer,
        },
        {
          headerName: "Proxy",
          width: 120,
          filter: "agTextColumnFilter",
          field: "ProxyIP",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
          floatingFilter: true,
          flex: 1,
          minWidth: 140,
          valueGetter:(params)=>{
            if(params.data.ProxyIP){
              return params.data.ProxyIP + ":" + params.data.ProxyPort
            }
            return "";
          }
        },
        {
          headerName: "Proxy Username",
          width: 140,
          filter: "agTextColumnFilter",
          field: "ProxyUsername",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
          floatingFilter: true,
          flex: 1,
          minWidth: 160,
        },
        {
          headerName: "Proxy Password",
          width: 140,
          filter: "agTextColumnFilter",
          field: "ProxyPassword",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
          floatingFilter: true,
          flex: 1,
          minWidth: 160,
        },
        {
          headerName: "P1",
          width: 140,
          filter: "agTextColumnFilter",
          field: "P1",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
          floatingFilter: true,
          flex: 1,
          minWidth: 160,
           valueFormatter: function(params) {
            if (params.value == null) {
              return "";
            } else {
              return String(params.value);
            }
          },
        },
        {
          headerName: "P2",
          width: 140,
          filter: "agTextColumnFilter",
          field: "P2",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
          floatingFilter: true,
          flex: 1,
          minWidth: 160,
           valueFormatter: function(params) {
            if (params.value == null) {
              return "";
            } else {
              return String(params.value);
            }
          },
        },
        {
          headerName: "P3",
          width: 140,
          filter: "agTextColumnFilter",
          field: "P3",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
          floatingFilter: true,
          flex: 1,
          minWidth: 160,
            valueFormatter: function(params) {
              if (params.value == null) {
                return "";
              } else {
                return String(params.value);
              }
            },
        },
          {
          headerName: "WaitRezCount",
          width: 140,
          filter: "agNumberColumnFilter",
          field: "WaitingReservationCount",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
          {
          headerName: "WaitAgencySideCount",
          width: 160,
          filter: "agNumberColumnFilter",
          field: "WaitAgencySideCount",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
         {
          headerName: "Hotel Names",
          width: 140,
          filter: "agTextColumnFilter",
          field: "HotelNames",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
          floatingFilter: true,
          flex: 1,
          minWidth: 160,
            valueFormatter: function(params) {
              if (params.value == null) {
                return "-";
              }
                else if(params.value.toLowerCase()=='all'){
                return "Bütün Oteller";
                }
              else {
                return String(params.value);
              }
            },
        },
        {
          headerName: "ControlRequired",
          width: 150,
          filter: false,
          field: "ControlRequired",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
          floatingFilter: false,
          cellRenderer: this.$CheckCellRenderer,
        },
        {
          headerName: "Link",
          field: "Link",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
          cellRenderer: function(event) {
            return (
              "<a target='_blank' href='" +
              event.value +
              "'>" +
              event.value +
              "</a>"
            );
          },
        },
      ],
      data: null,
      scanErrorsPop: null,
      scanResponseOpen: false,
      scanResponse: null,
      selectAll: false,
      isSelectCount: 0,
      authResponseOpen: false,
      authResponse: null,
      openCustomerProviderLogs: null,
      detailShow: null,
    };
  },
  created() {
    this.get();
  },
  watch: {
    selectAll() {
      if (!this.selectAll) {
        this.data.forEach((element) => {
          if (element.isSelected) {
            element.isSelected = false;
            this.$refs.agGrid.changeRow("Id", element);
          }
        });
        return false;
      }
      let pager = {
        min:
          this.$refs.agGrid.pager.currentPage *
          this.$refs.agGrid.pager.pageSize,
        max:
          (this.$refs.agGrid.pager.currentPage + 1) *
          this.$refs.agGrid.pager.pageSize,
      };
      this.$refs.agGrid.gridApi.forEachNodeAfterFilterAndSort(
        (rowNode, index) => {
          if (index >= pager.min && index < pager.max) {
            this.$refs.agGrid.changeRow("Id", {
              ...rowNode.data,
              isSelected: true,
            });
          }
        }
      );
    },
  },
  methods: {
    get() {
      this.data = null;
      this.selectAll = false;
      this.$appAxiosAdmin.get(`KOLAYREZ/CustomerProviders`).then((response) => {
        response.data.forEach((element) => {
          element.isSelected = false;
          element.StaticProxy=element.StaticProxy==null?false:element.StaticProxy;
          if (element.ReservationCount > 0) {
            element.Diff = (
              element.ProcessedReservationCount /
              (element.ReservationCount / 100)
            ).toFixed(2);
          } else {
            element.Diff = (0).toFixed(2);
          }
        });
        this.data = response.data;
      });
    },
    scan(item) {
      this.scanResponseOpen = true;
      this.scanResponse = null;
      this.$appAxiosKolayrez
        .get(`Helpers/Scan/` + item.Id)
        .then((response) => {
          this.scanResponse = response.data;
        })
        .catch((err) => {
          this.$isError(err);
        });
    },
    auth(item) {
      this.authResponseOpen = true;
      this.authResponse = null;
      this.$appAxiosKolayrez
        .get(`Helpers/Auth/` + item.Id)
        .then((response) => {
          this.authResponse = response.data;
        })
        .catch((err) => {
          this.authResponse = err;
        });
    },
    removeFromRedis(item) {
      this.$swal({
        icon: "question",
        title: "Warning!",
        text:
          "Are you sure you want to delete the redis named " +
          item.Username +
          "?",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((question) => {
        if (question.isConfirmed) {
          this.$appAxiosAdmin
            .delete(`KOLAYREZ/CustomerProviders/RemoveFromRedis/` + item.Id)
            .then(() => {
              this.$swal({
                icon: "success",
                title: "Success",
                text: "The customer redis has been successfully deleted.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
            })
            .catch((err) => {
              this.$isError(err);
            });
        }
      });
    },
    removeFromRedisAll() {
      let ids = [];
      for (
        let index = 0;
        index < this.$refs.agGrid.gridApi.getDisplayedRowCount();
        index++
      ) {
        if (
          this.$refs.agGrid.gridApi.getDisplayedRowAtIndex(index).data
            .isSelected
        ) {
          ids.push(
            this.$refs.agGrid.gridApi.getDisplayedRowAtIndex(index).data.Id
          );
        }
      }
      if (ids.length > 0) {
        this.$swal({
          icon: "question",
          title: "Warning!",
          text: "Are you sure you want to delete the redis?",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        }).then((question) => {
          if (question.isConfirmed) {
            this.$appAxiosAdmin
              .post(`KOLAYREZ/CustomerProviders/RemoveFromRedis`, ids)
              .then(() => {
                this.$swal({
                  icon: "success",
                  title: "Success",
                  text: "The customer redis has been successfully deleted.",
                  timer: 2000,
                  confirmButtonText: "Okey",
                });
              })
              .catch((err) => {
                this.$isError(err);
              });
          }
        });
      }
    },
    scanToQueue() {
      let ids = [];
      for (
        let index = 0;
        index < this.$refs.agGrid.gridApi.getDisplayedRowCount();
        index++
      ) {
        if (
          this.$refs.agGrid.gridApi.getDisplayedRowAtIndex(index).data
            .isSelected
        ) {
          ids.push(
            this.$refs.agGrid.gridApi.getDisplayedRowAtIndex(index).data.Id
          );
        }
      }
      if (ids.length > 0) {
        this.$swal({
          icon: "question",
          title: "Warning!",
          text: "Are you sure you want to scans?",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        }).then((question) => {
          if (question.isConfirmed) {
            this.$appAxiosAdmin
              .post(`KOLAYREZ/CustomerProviders/ScanToQueue`, ids)
              .then(() => {
                this.$swal({
                  icon: "success",
                  title: "Success",
                  text: "It has been successfully added to the scan queue.",
                  timer: 2000,
                  confirmButtonText: "Okey",
                });
              })
              .catch((err) => {
                this.$isError(err);
              });
          }
        });
      }
    },
    scanQue(item) {
      this.$appAxiosKolayrez
        .post(`Timer/Scan`, {
          CustomerId: null,
          ProviderId: null,
          CustomerProviderId: item.Id,
        })
        .then((response) => {
          this.$swal({
            icon: "success",
            title: "Success",
            text: response.data,
            timer: 2000,
            confirmButtonText: "Okey",
          });
        })
        .catch((err) => {
          this.$isError(err);
        });
    },
    testConnection(item) {
      this.$appAxiosKolayrez
        .post(`Helpers/Auth`, {
          ProviderId: item.ProviderId,
          Username: item.Username,
          Password: item.Password,
          Parameter: item.Parameter,
        })
        .then(() => {
          this.$swal({
            icon: "success",
            title: "Success",
            text: "Successfully connected.",
            timer: 2000,
            confirmButtonText: "Okey",
          });
        })
        .catch((err) => {
          this.$isError(err);
        });
    },
    clickedCellRezGrid(param) {
      console.log("param.data", param.data);
      if (param.colDef.field == "isSelected") {
        this.$refs.agGrid.changeRow("Id", {
          ...param.data,
          isSelected: !param.data.isSelected,
        });
        this.isSelectCount = this.data.filter((x) => x.isSelected).length;
      } else if (param.colDef.field != "Link") {
        this.detailShow = param.data;
      }
    },
    getContextMenuItems(params) {
      let result = [
        "copy",
        "export",
        {
          name: "Remove From Redis",
          icon: "<i class='mdi mdi-layers-off'></i>",
          action: () => {
            this.removeFromRedis(params.node.data);
          },
        },
        {
          name: "Scan Errors",
          icon: "<i class='fas fa-exclamation-triangle'></i>",
          action: () => {
            this.scanErrorsPop = params.node.data.Id;
          },
        },
        {
          name: "Scan",
          icon: "<i class='fas fa-sync-alt'></i>",
          action: () => {
            this.scan(params.node.data);
          },
        },
        {
          name: "Auth",
          icon: "<i class='fas fa-shield-alt'></i>",
          action: () => {
            this.auth(params.node.data);
          },
        },
        {
          name: "Scan Que",
          icon: "<i class='far fa-plus-square'></i>",
          action: () => {
            this.scanQue(params.node.data);
          },
        },
        {
          name: "Test Connection",
          icon: "<i class='fas fa-wifi'></i>",
          action: () => {
            this.testConnection(params.node.data);
          },
        },
        {
          name: "Customer Provider Logs",
          icon: '<i class="far fa-question-circle"></i>',
          action: () => {
            this.openCustomerProviderLogs = params.node.data;
          },
        },
      ];
      return result;
    },
  },
};
</script>
